﻿//*************************************************************************************
//* WaMS Custom Validators
//* Version 1.0
//* Author: Damian Koch
//* JavaScript component of custom ComponentModel.DataAnnotations.ValidationAttribute
//* Adds client-side support of RequiredIf, and ValidYearDuration
//* Requires jQuery, jQuery.validate, jQuery.validate.unobtrusive
//*************************************************************************************
import $ from 'jquery';
const jQuery = $;

jQuery(function () {
    jQuery.validator.addMethod('validyearduration', function (value, element, params) {
        if (value < 0) {
            return false;
        }
        return true;
    }, '');

    jQuery.validator.unobtrusive.adapters.add('validyearduration', function (options) {
        options.rules['validyearduration'] = {};
        options.messages['validyearduration'] = options.message;
    });

    jQuery.validator.addMethod('requiredif', function (value, element, parameters) {
        var name = '[name="' + parameters['dependentproperty'] + '"]';
        // get the target value (as a string, as that's what actual value will be)
        var targetvalue = parameters['targetvalue'];
        targetvalue = (targetvalue == null ? '' : targetvalue).toString();

        // get the actual value of the target control note - this probably needs to cater for more control types, e.g. radios
        var control = $(name, element.closest('form'));
        var controltype = control.attr('type');
        var actualvalue = controltype === 'checkbox' ? control.attr('checked').toString() : control.val();

        // if the condition is true, reuse the existing  required field validator functionality
        if (targetvalue === actualvalue) return $.validator.methods.required.call(this, value, element, parameters);

        return true;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredif', ['dependentproperty', 'targetvalue'], function (options) {
        options.rules['requiredif'] = { dependentproperty: options.params['dependentproperty'], targetvalue: options.params['targetvalue'] };
        options.messages['requiredif'] = options.message;
    });


    jQuery.validator.unobtrusive.adapters.add(
        'atleastonerequired', ['properties'], function (options) {
            options.rules['atleastonerequired'] = options.params;
            options.messages['atleastonerequired'] = options.message;
        }
    );

    jQuery.validator.addMethod('atleastonerequired', function (value, element, params) {
        var properties = params.properties.split(',');
        var values = $.map(properties, function (property, index) {
            var val = $('#' + property).val();
            return val != '' ? val : null;
        });
        return values.length > 0;
    }, '');

    jQuery.validator.unobtrusive.adapters.add(
        'countrequired', ['properties', 'requiredcount'], function (options) {
            options.rules['countrequired'] = options.params;
            options.messages['countrequired'] = options.message;
        }
    );

    jQuery.validator.addMethod('countrequired', function (value, element, params) {
        var properties = params.properties.split(',');

        var values = $.map(properties, function (property, index) {
            var name = '[name="' + property + '"]';
            var control = $(name, element.closest('form'));
            var val = control.val();
            return val != '' ? val : null;
        });
        return values.length == params.requiredcount;
    }, '');

    jQuery.validator.unobtrusive.adapters.add(
        'groupcountrequired', ['group', 'requiredcount'], function (options) {
            options.rules['groupcountrequired'] = options.params;
            options.messages['groupcountrequired'] = options.message;
        }
    );

    jQuery.validator.addMethod('groupcountrequired',
        function(value, element, params) {
            var name = '[data-val-groupcountrequired-group="' + params.group + '"]';
            var properties = $(name, element.closest('form'));
            var count = 0;
            properties.each(function() {
                if ($(this).val()) {
                    count++;
                }
            });
            return (count > params.requiredcount && value.length == 0) || count == params.requiredcount;
        },
        '');
    jQuery.validator.addMethod('requiredfile', function (value, element, params) {
        // Get the wrapper element
        const wrapper = $(element).closest('.uppy-wrapper');
        if (wrapper.length === 0) {
            return false;
        }

        // Check if there are any files in the file list
        const fileList = wrapper.find('.uppy-file-list');
        const fileCount = fileList.find('.uppy-file-item').length;

        return fileCount > 0;
    }, '');

    jQuery.validator.unobtrusive.adapters.add('requiredfile',
        function(options) {
            options.rules['requiredfile'] = {};
            options.messages['requiredfile'] = options.message;
        });
    jQuery.validator.addMethod('daterange', function (value, element, params) {
        if (!value) return true; // Let [Required] handle empty values

        var date = new Date(value);
        if (isNaN(date.getTime())) return false;

        if (params.min) {
            var minDate = new Date(params.min);
            if (date < minDate) return false;
        }

        if (params.max) {
            var maxDate = new Date(params.max);
            if (date > maxDate) return false;
        }

        return true;
    });

    jQuery.validator.unobtrusive.adapters.add('daterange', ['min', 'max'], function (options) {
        options.rules['daterange'] = {
            min: options.params.min,
            max: options.params.max
        };
        options.messages['daterange'] = options.message;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredfile', function (options) {
        options.rules['requiredfile'] = {};
        options.messages['requiredfile'] = options.message;
    });

    jQuery.validator.addMethod('numericlessthan', function (value, element, params) {
        var otherValue = $(params.element).val();

        if (isNaN(value) || isNaN(otherValue)) {
            return !value || !otherValue;
        }

        if (params.allowequality === true ||
            params.allowequality === 'True' ||
            params.allowequality === 'true') {
            return parseFloat(value) <= parseFloat(otherValue);
        }

        return parseFloat(value) < parseFloat(otherValue);
    }, '');

    jQuery.validator.unobtrusive.adapters.add('numericlessthan', ['other', 'allowequality'], function (options) {
        var prefix = options.element.name.substr(0, options.element.name.lastIndexOf('.') + 1),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(':input[name=' + fullOtherName + ']')[0];

        options.rules['numericlessthan'] = { allowequality: options.params.allowequality, element: element };
        if (options.message) {
            options.messages['numericlessthan'] = options.message;
        }
    });

    jQuery.validator.addMethod('numericgreaterthan', function (value, element, params) {
        var otherValue = $(params.element).val();

        if (isNaN(thisValue) || isNaN(compareValue)) {
            return false;
        }
        if (params.allowequality === true ||
            params.allowequality === 'True' ||
            params.allowequality === 'true') {
            return thisValue >= compareValue;
        }

        return thisValue > compareValue;
    }, '');

    jQuery.validator.unobtrusive.adapters.add('numericgreaterthan', ['other', 'allowequality'], function (options) {
        var prefix = options.element.name.substr(0, options.element.name.lastIndexOf('.') + 1),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(':input[name=' + fullOtherName + ']')[0];

        options.rules['numericgreaterthan'] = { allowequality: options.params.allowequality, element: element };
        if (options.message) {
            options.messages['numericgreaterthan'] = options.message;
        }
    });

}(jQuery));

